// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBySideSection_container__1mHPU","optionContainer":"SideBySideSection_optionContainer__M70T8"};